"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TracksType = void 0;
var TracksType;
(function (TracksType) {
    TracksType["Tracks"] = "tracks";
    TracksType["Favorite"] = "favorite";
    TracksType["Playlist"] = "playlist";
})(TracksType || (exports.TracksType = TracksType = {}));
